<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ clientIcon }}</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="clients"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell class="text-right">
                  <md-button
                    class="md-just-icon md-primary"
                    @click="viewItem(item.id)"
                  >
                    <md-tooltip>View Client</md-tooltip>
                    <md-icon>forward</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state>No Clients Found</md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>library_books</md-icon>
            </div>
            <h4 class="title">Reports</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-button
                  class="md-primary"
                  @click="onGenerateActivePlantReport()"
                  >Active Plant for All Clients</md-button
                ><br />
                <md-button
                  class="md-primary"
                  @click="onGeneratePlantSummarytReport()"
                  >Plant Summary</md-button
                >
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  async created() {
    await this.$store.dispatch("portfolio/getClientListing");
  },
  computed: {
    ...mapGetters({
      globalClient: "globalClient",
      clients: "portfolio/clients",
      clientIcon: "portfolio/icon"
    })
  },
  methods: {
    viewItem(id) {
      this.$router.push({
        name: "Client Details",
        params: { clientId: id }
      });
    },
    onGenerateActivePlantReport() {
      this.$store.dispatch("report/getActivePlantReport", {
        clientId: "0"
      });
    },
    onGeneratePlantSummarytReport() {
      this.$store.dispatch("report/getPlantSummaryReport");
    }
  },
  watch: {
    globalClient() {
      this.viewItem(this.globalClient.id);
    }
  }
};
</script>

<style></style>
